import { Controller } from "@hotwired/stimulus";

// Handles file upload UI with drag-and-drop and file selection feedback
export default class extends Controller {
  static targets = ["input", "dropzone", "placeholder", "preview", "filename", "removeBtn"];

  connect() {
    this.updatePreview();
  }

  // Triggered when file input changes
  change(_event) {
    this.updatePreview();
  }

  // Update the preview based on selected files
  updatePreview() {
    const files = this.inputTarget.files;

    if (files && files.length > 0) {
      // Show preview, hide placeholder
      this.placeholderTarget.classList.add("hidden");
      this.previewTarget.classList.remove("hidden");

      // Update filename display
      if (files.length === 1) {
        this.filenameTarget.textContent = files[0].name;
      } else {
        this.filenameTarget.textContent = `${files.length} files selected`;
      }

      // Update dropzone styling
      this.dropzoneTarget.classList.add("border-[#00ff88]", "bg-green-50", "dark:bg-green-900/20");
      this.dropzoneTarget.classList.remove("border-gray-300", "dark:border-gray-600");
    } else {
      // Show placeholder, hide preview
      this.placeholderTarget.classList.remove("hidden");
      this.previewTarget.classList.add("hidden");

      // Reset dropzone styling
      this.dropzoneTarget.classList.remove("border-[#00ff88]", "bg-green-50", "dark:bg-green-900/20");
      this.dropzoneTarget.classList.add("border-gray-300", "dark:border-gray-600");
    }
  }

  // Remove selected file(s)
  remove(event) {
    event.preventDefault();
    event.stopPropagation();
    this.inputTarget.value = "";
    this.updatePreview();
  }

  // Drag and drop handlers
  dragover(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add("border-[#00ff88]", "bg-green-50", "dark:bg-green-900/20");
  }

  dragleave(event) {
    event.preventDefault();
    if (!this.inputTarget.files?.length) {
      this.dropzoneTarget.classList.remove("border-[#00ff88]", "bg-green-50", "dark:bg-green-900/20");
    }
  }

  drop(event) {
    event.preventDefault();
    const files = event.dataTransfer.files;

    if (files.length > 0) {
      // Check if input accepts multiple files
      if (this.inputTarget.multiple) {
        this.inputTarget.files = files;
      } else {
        // Create a new DataTransfer to set single file
        const dt = new DataTransfer();
        dt.items.add(files[0]);
        this.inputTarget.files = dt.files;
      }
      this.updatePreview();
    }
  }
}
